<template>
    <div id="app">
      <router-view/>
    </div>
</template>
<script>

export default {
  name: 'App'
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto+Mono|Roboto:300,400,500&display=swap');
// basic html overrides
@import "styles/basics";
// layout
@import "styles/layout.scss";
// font styling
@import "styles/typography.scss";

#app {
  top:0;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  text-align: center;

  color: $off-white;

  height: 100vh;

  background: $black;
}
</style>
